/**
 * Created by robincoburn on 23/09/15.
 */
angular.module('qkr').directive('couponTerms', (appConfig) => ({

        restrict: 'E',
        scope: {
            terms: '=',
            isEdit: '=',
            isDraft: '=',
            canEdit: '=',
            termsErrors: '=',
            couponForm: '='
        },
        template: require('../../coupons/templates/couponTerms.html'),

        link(scope, element, attrs) {
            scope.isDisabled = (scope.isEdit && !scope.isDraft) || !scope.canEdit;

            const formatTerms = function() {
                const tempDiv = angular.element('#formatDiv');

                tempDiv[0].innerHTML = scope.terms;
                scope.terms = tempDiv[0].textContent;
                tempDiv.remove();
            };

            if (scope.isEdit) {
                formatTerms();
            }
        }
    }));



// WEBPACK FOOTER //
// ./src/coupons/directives/couponTerms.js